const AppRoutes = {
  Statistics: {
    Accounts: {
      path: '/statistic/accounts',
      label: 'Accounts'
    },
    OrderPayments: {
      path: '/statistic/order_payments',
      label: 'Order Payments'
    },
    Messages: {
      path: '/statistic/messages',
      label: 'Messages'
    },
    TenantDetails: {
      path: '/statistic/tenant_details',
      label: 'Tenant Details'
    }
  },
  Accounts: {
    ListAiHub: {
      path: '/ai-hub-accounts',
      label: 'Ai Hub'
    },
    ListAiStore: {
      path: '/ai-store-accounts',
      label: 'Ai Store'
    },
    ListAiReseller: {
      path: '/ai-reseller-accounts',
      label: 'Ai Reseller'
    },
    New: {
      path: '/accounts/new',
      label: 'Thêm Account'
    },
    Detail: {
      path: '/accounts/:accountId',
      label: 'Account details'
    }
  },
  Apps: {
    List: {
      path: '/apps',
      label: 'Apps'
    }
  },
  OrderPayments: {
    List: {
      path: '/order_payments',
      label: 'OrderPayments'
    },
    ListPartner: {
      path: '/order_payments_partner',
      label: 'OrderPaymentsPartner'
    }
  },
  RecommendApps: {
    List: {
      path: '/recommended_apps',
      label: 'RecommendApps'
    }
  },
  Subscriptions: {
    List: {
      path: '/subscriptions',
      label: 'Subscriptions'
    }
  },
  Tenants: {
    List: {
      path: '/tenants',
      label: 'Tenants'
    }
  },
  CustomDomains: {
    List: {
      path: '/custom_domains',
      label: 'CustomDomains'
    },
    Detail: {
      path: '/custom_domains/:customDomainId',
      label: 'Cập nhật CustomDomains'
    }
  },
  Credits: {
    List: {
      path: '/credits',
      label: 'Credits'
    }
  },
  MonthlyCredits: {
    List: {
      path: '/monthly_credits',
      label: 'Monthly Credits'
    }
  },
  PromoCodes: {
    List: {
      path: '/promo_codes',
      label: 'PromoCodes'
    },
    New: {
      path: '/promo_codes/new',
      label: 'Thêm PromoCode'
    },
    Detail: {
      path: '/promo_codes/:promoCodeId',
      label: 'Cập nhật PromoCode'
    }
  },
  Managers: {
    List: {
      path: '/managers',
      label: 'Managers'
    },
    New: {
      path: '/managers/new',
      label: 'Thêm Manager'
    },
    Detail: {
      path: '/managers/:managerId',
      label: 'Cập nhật Manager'
    }
  },
  Affiliates: {
    CommissionList: {
      path: '/commission-affiliates',
      label: 'Commission'
    },
    WithdrawList: {
      path: '/withdraw-affiliates',
      label: 'Withdraw'
    },
    CommissionStoreList: {
      path: '/commission-affiliates-store',
      label: 'Commission'
    },
    WithdrawStoreList: {
      path: '/withdraw-affiliates-store',
      label: 'Withdraw'
    },
    WithdrawDetail: {
      path: '/affiliates/withdraw/:affiliateId',
      label: 'Xử lý lệnh rút'
    }
  },
  Login: {
    path: '/login',
    label: 'Đăng nhập'
  },
  Contact: {
    path: '/lien-he',
    label: 'Liên hệ'
  }
};

export { AppRoutes };
